import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import Tibbit_00 from '@appblocks/codegeneration/Tibbits/Tibbit_00';
import {
    SettingType,
    CodeBlock,
    BlockType,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
} from '@appblocks/codegeneration/types';
import Tibbits from '@appblocks/codegeneration/Tibbits';

export default class Keypad extends BaseFeature {
    constructor() {
        super();
        this.name = 'Keypad';
        this.id = 'kp';
        this.priority = 50;
        this.requirements = [['md_button', 'input']];
    }

    getCodeBlocks() {
        const { project } = this;
        const blocks: Array<CodeBlock> = [];
        if (project.runtime === 'simulator') {
            blocks.push({
                location: 'SIMULATOR_OS',
                blockType: BlockType.CODE,
                template: `
const PL_KP_EVENT_RELEASED = 0;
const PL_KP_EVENT_PRESSED = 1;

const LCD_KEYPAD_1 = 0;
const LCD_KEYPAD_2 = 1;
const LCD_KEYPAD_3 = 2;
const LCD_KEYPAD_4 = 3;
`,
            });
            return blocks;
        }
        let kpIndex = 0;
        // Keypad push buttons
        let key_codes: string[] = [];
        const key_codes_hashmap = new Map();
        for (let i = 0; i < project.features.length; i += 1) {
            const tibbit = project.features[i].getSettingValue('TIBBIT');
            const feature: any = project.features[i];
            let variable;
            let pin;
            let lines;
            switch (tibbit) {
                case '38':
                    pin = Tibbits.getSocketPinNumbers((Number(project.features[i].getSettingValue('SOCKET')) - 1).toString(), this.project.device.id)[0];
                    if (!key_codes_hashmap.has(pin)) {
                        key_codes_hashmap.set(pin, kpIndex++);
                    }
                    variable = project.features[i].getSettingValue('BUTTON_NAME');
                    blocks.push({
                        location: 'GLOBAL_CONSTS',
                        blockType: BlockType.CODE,
                        template: `
const ${variable}=${key_codes_hashmap.get(pin)}
            `,
                    });
                    break;
                default:
                    break;
            }

            // see if feature is subclass of IOTibbit
            if (tibbit !== undefined && feature.lines !== undefined && feature.mode !== undefined) {
                lines = feature.lines;
                for (let j = 1; j <= lines; j += 1) {
                    if (project.features[i].getSettingValue(`L${j}MODE`) === IOLinesMode.Button) {
                        variable = project.features[i].getSettingValue(`L${j}NAME`);
                        pin = Tibbits.getSocketPinNumbers((Number(project.features[i].getSettingValue('SOCKET'))).toString(), this.project.device.id)[j - 1];
                        if (!key_codes_hashmap.has(pin)) {
                            key_codes_hashmap.set(pin, kpIndex++);
                        }
                        blocks.push({
                            location: 'GLOBAL_CONSTS',
                            blockType: BlockType.CODE,
                            template: `
const ${variable}_kp=${key_codes_hashmap.get(pin)}
                `,
                        });
                    }
                }
            }
            if (project.features[i].id === 'lcd') {
                if (project.features[i].getSettingValue('ENABLED')) {
                    const lcdKeypadLines = ['36', '37', '38', '39'];
                    for (let i = 0; i < lcdKeypadLines.length; i++) {
                        key_codes_hashmap.set(lcdKeypadLines[i], kpIndex++);
                        blocks.push({
                            location: 'GLOBAL_CONSTS',
                            blockType: BlockType.CODE,
                            template: `
const LCD_KEYPAD_${i + 1}=${key_codes_hashmap.get(lcdKeypadLines[i])}
                `,
                        });
                    }
                    blocks.push({
                        location: 'boot_complete',
                        blockType: BlockType.CODE,
                        template: `
    '----- KEYPAD -----
    io.num=PL_IO_NUM_44
    io.enabled=YES
    io.state=LOW`,
                    });
                }
            }
        }
        key_codes = Array.from(key_codes_hashmap.keys());
        if (key_codes.length > 0) {
            const keys_str = key_codes.join(',');
            blocks.push({
                // needs to happen after lcd is set up
                location: 'boot_complete',
                blockType: BlockType.CODE,
                template: `
    kp.returnlinesmapping="${keys_str}"
    kp.releasedelay=3
    kp.enabled=YES`,
            });
        }


        return blocks;
    }
}
